export { default } from './SubscriptionsDefaultSettings';
